import Grid from "@material-ui/core/Grid";
import { type ReactNode, useState } from "react";
import { Filters } from "./filters";
import { useSearchWorkOrders } from "./hooks/useSearchWorkOrders";
import WorkOrders from "./workOrders";
import { ErrorModal } from "@dexteel/mesf-core";

interface TabPanelProps {
	children?: ReactNode;
	index: number;
	value: number;
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index } = props;

	return (
		<>
			{value === index && (
				<Grid
					item
					md={12}
					xs={12}
					style={{ height: "100%", width: "100%", paddingTop: 0 }}
				>
					{children}
				</Grid>
			)}
		</>
	);
}

type Props = {};

export default function WorkOrdersTabs({}: Props) {
	const [value, setValue] = useState<number>(0);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");

	const searchWorkOrders = useSearchWorkOrders({ setIsLoading, setError });

	const onKeyDown = (e: any) => {
		if (e.keyCode === 13) {
			searchWorkOrders();
		}
	};

	return (
		<>
			<TabPanel value={value} index={0}>
				<Filters onKeyDown={onKeyDown} searchWorkOrders={searchWorkOrders} />
				<WorkOrders searchWorkOrders={searchWorkOrders} isLoading={isLoading} />
			</TabPanel>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
}
